import { PdfViewer } from '@/features/pdf-viewer'
import { ToolPageShell } from '@/shared/seo'

export function OtkrytPdfPage() {
  return (
    <ToolPageShell utilityKey="pdf-viewer">
      <PdfViewer />
    </ToolPageShell>
  )
}
